import { createArrayFromIndexedArray } from '@common/utils/helpers/array/create-array-from-indexed-array';
import { CouplingType } from '@common/types';

export const couplingTypes2table = (data: Array<CouplingType>) => {
  return createArrayFromIndexedArray(data).map((item, i) => {
    return {
      ...item,
      key: item.ID ?? 'row' + i
    };
  });
};
